function pug_attr(t,e,n,r){if(!1===e||null==e||!e&&("class"===t||"style"===t))return"";if(!0===e)return" "+(r?t:t+'="'+t+'"');var f=typeof e;return"object"!==f&&"function"!==f||"function"!=typeof e.toJSON||(e=e.toJSON()),"string"==typeof e||(e=JSON.stringify(e),n||-1===e.indexOf('"'))?(n&&(e=pug_escape(e))," "+t+'="'+e+'"'):" "+t+"='"+e.replace(/'/g,"&#39;")+"'"}
function pug_classes(s,r){return Array.isArray(s)?pug_classes_array(s,r):s&&"object"==typeof s?pug_classes_object(s):s||""}
function pug_classes_array(r,a){for(var s,e="",u="",c=Array.isArray(a),g=0;g<r.length;g++)(s=pug_classes(r[g]))&&(c&&a[g]&&(s=pug_escape(s)),e=e+u+s,u=" ");return e}
function pug_classes_object(r){var a="",n="";for(var o in r)o&&r[o]&&pug_has_own_property.call(r,o)&&(a=a+n+o,n=" ");return a}
function pug_escape(e){var a=""+e,t=pug_match_html.exec(a);if(!t)return e;var r,c,n,s="";for(r=t.index,c=0;r<a.length;r++){switch(a.charCodeAt(r)){case 34:n="&quot;";break;case 38:n="&amp;";break;case 60:n="&lt;";break;case 62:n="&gt;";break;default:continue}c!==r&&(s+=a.substring(c,r)),c=r+1,s+=n}return c!==r?s+a.substring(c,r):s}
var pug_has_own_property=Object.prototype.hasOwnProperty;
var pug_match_html=/["&<>]/;function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (Array, complete, i18n, ids, image, klass, letters, multiline, word) {
      pug_mixins["image"] = pug_interp = function(imageUrl, klass, alt){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cimg" + (pug_attr("class", pug_classes([klass], [true]), false, true)+pug_attr("src", imageUrl, true, true)+pug_attr("alt", alt, true, true)) + "\u003E";
};
pug_mixins["image"] = pug_interp = function(imageUrl, klass, alt){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cimg" + (pug_attr("class", pug_classes([klass], [true]), false, true)+pug_attr("src", imageUrl, true, true)+pug_attr("alt", alt, true, true)) + "\u003E";
};
var klass = "jumble-answer-" + word.toLowerCase();
var multiline = /[\s-]/.test(word) && word.length > 7;
if (multiline) klass += " multiline";
pug_html = pug_html + "\u003Cdiv class=\"jumble-top\"\u003E\u003Cdiv class=\"jumble-top-content block-h-xl\"\u003E\u003Cdiv class=\"block-v-md\"\u003E\u003Cdiv class=\"jumble-image-container block-lt block-v-sm\"\u003E";
pug_mixins["image"](image,'jumble-image content-ver');
pug_html = pug_html + "\u003Cdiv class=\"jumble-masks\"\u003E";
// iterate (new Array(60))
;(function(){
  var $$obj = (new Array(60));
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var m = $$obj[pug_index0];
pug_html = pug_html + "\u003Cdiv class=\"jumble-mask\"\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var m = $$obj[pug_index0];
pug_html = pug_html + "\u003Cdiv class=\"jumble-mask\"\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv" + (pug_attr("class", pug_classes(["jumble-answer","block-v-sm",klass], [false,false,true]), false, true)) + "\u003E";
// iterate word
;(function(){
  var $$obj = word;
  if ('number' == typeof $$obj.length) {
      for (var j = 0, $$l = $$obj.length; j < $$l; j++) {
        var letter = $$obj[j];
var i = complete.indexOf(letter);
if (/[\s-]/.test(letter)) {
if (multiline) {
if (letter != " ") {
pug_html = pug_html + "\u003Cdiv class=\"droppy-complete\"\u003E" + (pug_escape(null == (pug_interp = letter) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"line-br-sm\"\u003E\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cbr\u003E";
}
}
else {
pug_html = pug_html + "\u003Cdiv class=\"droppy-complete\"\u003E&nbsp;\u003C\u002Fdiv\u003E";
}
}
else
if (i > -1) {
complete[i] = null;
pug_html = pug_html + "\u003Cdiv class=\"droppy-complete\"\u003E\u003Cdiv class=\"letter\"\u003E" + (pug_escape(null == (pug_interp = letter) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv" + (" class=\"droppy\""+pug_attr("data-letter", letter, true, true)) + "\u003E\u003Cdiv class=\"letter\"\u003E&nbsp;\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var j in $$obj) {
      $$l++;
      var letter = $$obj[j];
var i = complete.indexOf(letter);
if (/[\s-]/.test(letter)) {
if (multiline) {
if (letter != " ") {
pug_html = pug_html + "\u003Cdiv class=\"droppy-complete\"\u003E" + (pug_escape(null == (pug_interp = letter) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"line-br-sm\"\u003E\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cbr\u003E";
}
}
else {
pug_html = pug_html + "\u003Cdiv class=\"droppy-complete\"\u003E&nbsp;\u003C\u002Fdiv\u003E";
}
}
else
if (i > -1) {
complete[i] = null;
pug_html = pug_html + "\u003Cdiv class=\"droppy-complete\"\u003E\u003Cdiv class=\"letter\"\u003E" + (pug_escape(null == (pug_interp = letter) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv" + (" class=\"droppy\""+pug_attr("data-letter", letter, true, true)) + "\u003E\u003Cdiv class=\"letter\"\u003E&nbsp;\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"jumble-letters block-md clearfix\"\u003E\u003Ch4 class=\"jumble-prompt text-md-left block-sm\"\u003E" + (pug_escape(null == (pug_interp = i18n("game-jumble.drag-letters")) ? "" : pug_interp)) + "\u003C\u002Fh4\u003E";
// iterate letters
;(function(){
  var $$obj = letters;
  if ('number' == typeof $$obj.length) {
      for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
        var letter = $$obj[i];
pug_html = pug_html + "\u003Cdiv" + (pug_attr("class", pug_classes(["draggy","bold",`draggy-${i}`], [false,false,true]), false, true)+pug_attr("data-id", ids[i], true, true)+pug_attr("data-letter", letter, true, true)) + "\u003E\u003Cdiv class=\"letter\"\u003E" + (pug_escape(null == (pug_interp = letter) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;
      var letter = $$obj[i];
pug_html = pug_html + "\u003Cdiv" + (pug_attr("class", pug_classes(["draggy","bold",`draggy-${i}`], [false,false,true]), false, true)+pug_attr("data-id", ids[i], true, true)+pug_attr("data-letter", letter, true, true)) + "\u003E\u003Cdiv class=\"letter\"\u003E" + (pug_escape(null == (pug_interp = letter) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
    }.call(this, "Array" in locals_for_with ?
        locals_for_with.Array :
        typeof Array !== 'undefined' ? Array : undefined, "complete" in locals_for_with ?
        locals_for_with.complete :
        typeof complete !== 'undefined' ? complete : undefined, "i18n" in locals_for_with ?
        locals_for_with.i18n :
        typeof i18n !== 'undefined' ? i18n : undefined, "ids" in locals_for_with ?
        locals_for_with.ids :
        typeof ids !== 'undefined' ? ids : undefined, "image" in locals_for_with ?
        locals_for_with.image :
        typeof image !== 'undefined' ? image : undefined, "klass" in locals_for_with ?
        locals_for_with.klass :
        typeof klass !== 'undefined' ? klass : undefined, "letters" in locals_for_with ?
        locals_for_with.letters :
        typeof letters !== 'undefined' ? letters : undefined, "multiline" in locals_for_with ?
        locals_for_with.multiline :
        typeof multiline !== 'undefined' ? multiline : undefined, "word" in locals_for_with ?
        locals_for_with.word :
        typeof word !== 'undefined' ? word : undefined));
    ;;return pug_html;};module.exports=template;